import { useState } from "react";
import { Link } from "react-router-dom";
import { usePageMeta } from "../../hooks/usePageMeta";
import { FAQS } from "../../mocks/faq";
import Breadcrumb from "../../components/feature/Breadcrumb";

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  usePageMeta({
    title: "吃瓜指南 · 常见问题解答",
    description:
      "吃瓜17吃瓜指南：解答关于更新节奏、栏目使用、热度计算与转载原则等常见问题。有任何疑问，欢迎通过关于我们页面联系反馈。",
    keywords: "吃瓜17,吃瓜指南,常见问题,更新节奏,转载原则",
    path: "/faq",
    schema: [
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: FAQS.map((f) => ({
          "@type": "Question",
          name: f.q,
          acceptedAnswer: { "@type": "Answer", text: f.a },
        })),
      },
      {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [{ "@type": "ListItem", position: 1, name: "今日首页", item: "https://xttkax.cn/" }, { "@type": "ListItem", position: 2, name: "吃瓜指南" }],
      },
    ],
  });

  return (
    <div className="pt-16 md:pt-[72px]">
      <div className="bg-primary-100/60 py-10 md:py-16">
        <div className="mx-auto max-w-[1200px] px-4 md:px-6">
          <Breadcrumb items={[{ label: "今日首页", to: "/" }, { label: "吃瓜指南" }]} />
          <div className="mt-6 flex flex-col items-start justify-between gap-6 md:flex-row md:items-end">
            <div>
              <span className="inline-flex items-center gap-2 rounded-full bg-primary-500 px-4 py-1.5 text-sm font-semibold text-background-50">
                <i className="ri-lifebuoy-line" aria-hidden="true"></i>Help Center
              </span>
              <h1 className="mt-4 font-heading text-3xl font-bold text-foreground-950 md:text-5xl">吃瓜指南</h1>
              <p className="mt-4 max-w-2xl text-foreground-700">关于网站怎么用、内容从哪来，所有你想知道的常见问题都在这里。</p>
            </div>
          </div>
        </div>
      </div>

      <div className="mx-auto max-w-3xl px-4 py-12 md:px-6 md:py-16">
        <div className="divide-y divide-background-200/80 overflow-hidden rounded-3xl border border-background-200/70 bg-background-50">
          {FAQS.map((item, i) => {
            const open = openIdx === i;
            return (
              <div key={i}>
                <h2>
                  <button
                    type="button"
                    onClick={() => setOpenIdx(open ? null : i)}
                    className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left transition-colors hover:bg-secondary-100/50"
                    aria-expanded={open}
                  >
                    <span className="flex items-center gap-3">
                      <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-sm font-bold ${open ? "bg-primary-500 text-background-50" : "bg-secondary-200 text-foreground-600"}`}>
                        {String(i + 1).padStart(2, "0")}
                      </span>
                      <span className="font-heading text-base font-bold text-foreground-950 md:text-lg">{item.q}</span>
                    </span>
                    <i className={`${open ? "ri-subtract-line" : "ri-add-line"} shrink-0 text-xl text-primary-600`} aria-hidden="true"></i>
                  </button>
                </h2>
                {open && (
                  <div className="px-6 pb-6 pl-16">
                    <p className="leading-8 text-foreground-700">{item.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>

        <section className="mt-10 rounded-3xl bg-secondary-100 p-8 text-center">
          <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">还是没找到答案？</h2>
          <p className="mx-auto mt-3 max-w-xl text-foreground-600">
            关于投稿、纠错或内容合作，欢迎通过关于我们页面的联系方式与我们沟通，我们会尽快回复。
          </p>
          <div className="mt-6 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <Link to="/about" className="inline-flex items-center gap-2 rounded-full bg-primary-500 px-6 py-3 text-sm font-semibold whitespace-nowrap text-background-50 transition-colors hover:bg-primary-600">
              <i className="ri-message-3-line" aria-hidden="true"></i>联系我们
            </Link>
            <Link to="/news" className="inline-flex items-center gap-2 rounded-full border border-background-200 bg-background-50 px-6 py-3 text-sm font-semibold whitespace-nowrap text-foreground-800 transition-colors hover:bg-secondary-200">
              <i className="ri-article-line" aria-hidden="true"></i>看看今日速递
            </Link>
          </div>
        </section>
      </div>
    </div>
  );
}